import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from '@heroui/react';
import { FC } from 'react';

type Placement = 'left' | 'right'| 'top' | 'bottom';

interface DrawerContainerProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
  onClose: () => void;
  placement?: Placement;
  backdrop?: 'blur' | 'opaque' | 'transparent';
  onOpenChange?: () => void;
  highZIndex?: boolean;
  /** Klasy na treści szuflady — np. `overflow-hidden`, gdy zawartość ma się nie przewijać. */
  bodyClassName?: string;
  /** Zdanie wyjaśniające pod tytułem — po co ta szuflada i co w niej widać. */
  subtitle?: string;
}

export const DrawerContainer:FC<DrawerContainerProps> = ({
  title, children, isOpen, size, onClose, onOpenChange,
  placement = 'right',
  backdrop = 'blur',
  highZIndex = false,
  bodyClassName,
  subtitle,
}) => (
  <Drawer
    isOpen={isOpen}
    size={size}
    onClose={onClose}
    placement={placement}
    isDismissable={false}
    radius="none"
    /* Tło pod szufladą: biała mgła z rozmyciem zamiast czarnego przyciemnienia (DS, jak w audycie).
       Szuflada bez cienia, od treści oddziela ją linia border-default. Prop `backdrop` zostaje
       dla zgodności, ale wygląd jest jeden dla całego panelu ('transparent' nadal wyłącza tło). */
    backdrop={backdrop === 'transparent' ? 'transparent' : 'blur'}
    onOpenChange={onOpenChange}
    classNames={{
      wrapper: highZIndex ? 'z-[1100]' : undefined,
      backdrop: `bg-white/50 backdrop-blur-[3px]${highZIndex ? ' z-[1100]' : ''}`,
      base: 'shadow-none border-l border-border-default',
    }}
  >

    <DrawerContent>
      {() => (
        <>
          <DrawerHeader className="flex flex-col gap-1">
            <h6 className="text-[16px]">{title}</h6>
            {subtitle && (
              <p className="text-[12px] font-normal leading-snug text-default-500">{subtitle}</p>
            )}
          </DrawerHeader>
          <DrawerBody className={bodyClassName}>
            {children}
          </DrawerBody>
        </>
      )}
    </DrawerContent>
  </Drawer>
);
